export default __webpack_public_path__ + "static/test-setup-light-08b3385011da18a8fdf80a78718af319.png";